import React from 'react';
import { Section } from './Section';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Después de mi parto me sentía invisible e hinchada todo el tiempo. RENACIDA me ayudó a entender lo que me pasaba y a recuperarme de verdad. Por fin me siento yo otra vez.',
    author: 'Daniela M.',
    role: 'mamá de 7 meses',
    initials: 'DM'
  }, {
    quote: 'Pensé que el agotamiento y la tristeza eran normales y que tenía que aguantar. Este ebook me abrió los ojos y me dio las herramientas que necesitaba. Lo mejor que hice por mí.',
    author: 'Sofía R.',
    role: 'mamá primeriza',
    initials: 'SR'
  }, {
    quote: 'Lloraba sin saber por qué. Estaba hinchada, sin energía y perdida. RENACIDA fue como una amiga que finalmente me entendió y me dijo qué hacer. Gracias de corazón.',
    author: 'Valentina G.',
    role: 'mamá de gemelos',
    initials: 'VG'
  }];
  return <Section className="bg-cream-dark/30 py-20" data-id="element-179">
      <div className="text-center mb-16" data-id="element-180">
        <h2 className="text-3xl md:text-4xl font-serif mb-4" data-id="element-181">
          Lo que dicen otras mamás
        </h2>
        <div className="flex justify-center gap-1 text-rose-light" data-id="element-182">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-183" />)}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-184">
        {testimonials.map((test, index) => <div key={index} className="bg-white p-8 rounded-3xl shadow-sm relative" data-id="element-185">
            <div className="text-rose-light/30 font-serif text-6xl absolute top-4 left-6 leading-none" data-id="element-186">
              "
            </div>
            <p className="text-brown-light italic mb-8 relative z-10 pt-4" data-id="element-187">
              {test.quote}
            </p>
            <div className="flex items-center gap-4" data-id="element-188">
              <div className="w-12 h-12 bg-cream-dark rounded-full flex items-center justify-center font-serif text-rose-dark font-medium" data-id="element-189">
                {test.initials}
              </div>
              <div data-id="element-190">
                <p className="font-medium text-brown-dark" data-id="element-191">{test.author}</p>
                <p className="text-sm text-brown-light" data-id="element-192">{test.role}</p>
              </div>
            </div>
          </div>)}
      </div>
    </Section>;
}